import { retryWithBackoff } from './retry_with_backoff';
export async function fetchAllPages(callApi, maxRetriesPerPage) {
    const result = {
        data: [],
        totalSize: 0,
    };
    let nextPageToken;
    do {
        const response = await retryWithBackoff(() => callApi(nextPageToken), maxRetriesPerPage);
        if (response instanceof Error) {
            throw response;
        }
        result.data.push(...response.data);
        if (response.totalSize != null) {
            result.totalSize = response.totalSize;
        }
        nextPageToken = response.nextPageToken;
    } while (nextPageToken != null);
    return result;
}
//# sourceMappingURL=fetch_all_pages.js.map